
define(
  'GoferParts.EntryPoint',
  [
    'GoferParts.Main.View',
    'Facets.Model'
  ],
  function (
    GoferPartsMainView,
    FacetsModel
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var facets = new FacetsModel();

        var pageType = container.getComponent('PageType');
        pageType.registerPageType({
          name: 'gofer-parts',
          routes: ['gofer-parts', 'gofer-parts/:model', 'gofer-parts/:model?:options'],
          options: {
            model: facets
          },
          view: GoferPartsMainView
        });
      }
    };
  }
);
